var map = {
	"./Group1.png": 1369,
	"./Group1@2x.png": 2683,
	"./away-from-home-pet1.png": 8713,
	"./away-from-home-pet1@2x.png": 5291,
	"./away-from-home-pet2.png": 1189,
	"./away-from-home-pet2@2x.png": 8082,
	"./away-from-home-pet3.png": 8923,
	"./away-from-home-pet3@2x.png": 6325,
	"./away-from-home-pet3_2.png": 4940,
	"./away-from-home-pet3_2@2x.png": 6076,
	"./away-from-home.png": 5630,
	"./away-from-home@2x.png": 1190,
	"./egle.png": 5618,
	"./egle@2x.png": 8770,
	"./fish.png": 4445,
	"./fish@2x.png": 1895,
	"./gifting-pet1.png": 6684,
	"./gifting-pet1@2x.png": 748,
	"./gifting-pet2.png": 6743,
	"./gifting-pet2@2x.png": 5513,
	"./gifting-pet3.png": 8430,
	"./gifting-pet3@2x.png": 8809,
	"./gifting-pet3_2.png": 9585,
	"./gifting-pet3_2@2x.png": 3667,
	"./gifting-pet4.png": 9441,
	"./gifting-pet4@2x.png": 9491,
	"./gifting-pet5.png": 1576,
	"./gifting-pet5@2x.png": 9280,
	"./gifting-pet6.png": 6851,
	"./gifting-pet6@2x.png": 4381,
	"./gifting.png": 4757,
	"./gifting@2x.png": 1631,
	"./group2.png": 2754,
	"./group2@2x.png": 6946,
	"./love-pet1.png": 5310,
	"./love-pet1@2x.png": 7078,
	"./love-pet1_2.png": 7569,
	"./love-pet1_2@2x.png": 7843,
	"./love-pet2.png": 3141,
	"./love-pet2@2x.png": 9247,
	"./love-pet3.png": 876,
	"./love-pet3@2x.png": 1708,
	"./love-pet3_2.png": 4535,
	"./love-pet3_2@2x.png": 3529,
	"./love-pet4.png": 8275,
	"./love-pet4@2x.png": 5581,
	"./love-pet5.png": 6362,
	"./love-pet5@2x.png": 5802,
	"./love-pet5_2.png": 2629,
	"./love-pet5_2@2x.png": 9375,
	"./love-pet6.png": 3793,
	"./love-pet6@2x.png": 4723,
	"./love.png": 9059,
	"./love@2x.png": 3853,
	"./memorial-pet1.png": 1720,
	"./memorial-pet1@2x.png": 7427,
	"./memorial-pet2.png": 7475,
	"./memorial-pet2@2x.png": 7165,
	"./memorial-pet3.png": 2266,
	"./memorial-pet3@2x.png": 8762,
	"./memorial-pet3_2.png": 581,
	"./memorial-pet3_2@2x.png": 6623,
	"./memorial-pet5.png": 7842,
	"./memorial-pet5@2x.png": 5436,
	"./memorial.png": 1969,
	"./memorial@2x.png": 7027,
	"./oxytocin.png": 8042,
	"./oxytocin@2x.png": 538,
	"./parrot.png": 9331,
	"./parrot2.png": 9737,
	"./parrot2@2x.png": 267,
	"./parrot3.png": 5536,
	"./parrot3@2x.png": 3784,
	"./parrot@2x.png": 7341,
	"./rabbit.png": 2107,
	"./rabbit@2x.png": 8469,
	"./selection.gif": 7182,
	"./selection.png": 6881,
	"./selection@2x.png": 9283,
	"./wild-animal-love.png": 3481,
	"./wild-animal-love@2x.png": 7291,
	"./wild-animal-pet1.png": 3521,
	"./wild-animal-pet1@2x.png": 5843,
	"./wild-animal-pet2.png": 6090,
	"./wild-animal-pet2@2x.png": 6922,
	"./wild-animal-pet3.png": 8003,
	"./wild-animal-pet3@2x.png": 349,
	"./wild-animal-pet4.png": 604,
	"./wild-animal-pet4@2x.png": 6476,
	"./wild-animal-pet4_2.png": 8551,
	"./wild-animal-pet4_2@2x.png": 1769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6811;